// extracted by mini-css-extract-plugin
export default {"price":"p_-z","onSale":"q_-z","msrpLabelPrice":"r_-z","msrpLabel":"s_-z","originalPrice":"t_-z","percentOff":"u_-z"};